/**
 * Vesper Event Store (Shared)
 */

import { create } from 'zustand';
import type { Event, EventWithMembers } from '../types/event.types';

interface EventStore {
  events: Event[];
  selectedEvent: EventWithMembers | null;
  isLoading: boolean;

  setEvents: (events: Event[]) => void;
  setSelectedEvent: (event: EventWithMembers | null) => void;
  setLoading: (loading: boolean) => void;
  addEvent: (event: Event) => void;
}

export const useEventStore = create<EventStore>((set) => ({
  events: [],
  selectedEvent: null,
  isLoading: false,

  setEvents: (events) => set({ events }),
  setSelectedEvent: (selectedEvent) => set({ selectedEvent }),
  setLoading: (isLoading) => set({ isLoading }),
  addEvent: (event) => set((state) => ({ events: [event, ...state.events] })),
}));
